import _ from 'lodash'
import Constants from '@/constants'
import Request from './request'
import StringHelper from './string'

class Validators {
  // boolean

  static validatorIntOrNull (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }
    if (required) {
      required = new Error('Required')
    }

    // value
    if (value === null) {
      return callback()
    }
    if (value === undefined) {
      return callback(required)
    }
    if (typeof value !== 'number' || isNaN(parseInt(value, 10))) {
      return callback(new Error('Invalid ID'))
    }
    return callback()
  }

  static validateBoolean (value, required = true) {
    if (value === undefined || value === null) {
      return !required
    }
    if (typeof value !== 'boolean') {
      return false
    }
    if (value !== true && value !== false) {
      return false
    }
    return true
  }

  static validatorBoolean (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }
    if (required) {
      required = new Error('Required')
    }

    // value
    if (value === undefined || value === null) {
      return callback(required)
    }
    if (value !== true && value !== false) {
      return callback(new Error('Invalid boolean'))
    }
    return callback()
  }

  static validatorBooleanInt (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }
    if (required) {
      required = new Error('Required')
    }

    // value
    if (value === undefined || value === null) {
      return callback(required)
    }
    if (value !== Constants.OptionsYesNo.YES &&
      value !== Constants.OptionsYesNo.NO &&
      value !== Constants.OptionsYesNo.UNKNOWN) {
      return callback(new Error('Invalid boolean'))
    }
    return callback()
  }

  // select

  static validatorSelectOrCreateNew (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }
    if (required) {
      required = new Error('Required')
    }

    // value
    if (value == null || (typeof value === 'string' && value.length <= 0)) {
      return callback(required)
    }
    return callback()
  }

  // file

  static validateFileRequired (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    if (value !== null && value && value.length > 0 && value[0] && !_.isEmpty(value[0])) {
      return callback()
    } else {
      return callback(new Error('Required'))
    }
  }

  // array

  // static validatorArrayRequired (rule, value, callback) { // not used, modify baseform instead
  //   console.log('-- validator array required', {
  //     rule,
  //     value,
  //     callback
  //   })
  //   // required
  //   let required
  //   if (rule && rule.hasOwnProperty('required')) {
  //     required = rule.required
  //   }
  //   required = required ? new Error('Required') : undefined
  //   if (value == null) return callback(required)
  //   if (typeof value !== 'object') return callback(required)
  //   if (!Array.isArray(value)) return callback(required)
  //
  //   let atLeastOnce = rule.hasOwnProperty('atLeastOnce') && rule.atLeastOnce
  //   if (atLeastOnce && (!value || value.length <= 0)) {
  //     return callback(required)
  //   }
  //
  //   // value
  //   for (let i in value) {
  //     let item = value[i]
  //     if (required && item == null) return callback(required)
  //     if (item == null) continue
  //
  //     // item val
  //     let attrName = rule.hasOwnProperty('attrName') ? rule.attrName : undefined
  //     let val = attrName ? item[attrName] : item
  //     if (required && val == null) return callback(required)
  //     // if (val == null) continue
  //   }
  //   return callback()
  // }

  // object?
  static validateArrayAtLeastOne (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    let attrName = rule.attrName || 'value'
    if (value && value.length > 0) {
      for (let v in value) {
        let val = value[v]
        if (!val || !val[attrName] || val[attrName].trim().length <= 0) {
          return callback(new Error('Required'))
        }
      }
      return callback()
    } else {
      return callback(new Error('Required'))
    }
  }

  static validateArrayMinMax (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    if (rule.hasOwnProperty('min') && (value.length < rule.min)) {
      return callback(new Error(rule.message || `Min ${rule.min} item(s) required`))
    }
    if (rule.hasOwnProperty('max') && (value.length > rule.max)) {
      return callback(new Error(rule.message || `Max ${rule.max} item(s) exceeded`))
    }
    return callback()
  }

  static validateArrayStringMinMax (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    // console.log('-- validate array string min max', {
    //   value
    // })
    if (value && value.length > 0) {
      for (let v in value) {
        let val = value[v]
        if (rule.hasOwnProperty('attrName')) {
          val = val[rule.attrName]
        }
        if (val == null) val = ''
        val = `${val}`
        if (rule.hasOwnProperty('min') && rule.min != null && (val.length < rule.min)) {
          return callback(new Error(rule.message || `Min ${rule.min} character(s) required`))
        }
        if (rule.hasOwnProperty('max') && rule.max != null && (val.length > rule.max)) {
          return callback(new Error(rule.message || `Max ${rule.max} character(s) exceeded`))
        }
      }
      return callback()
    } else {
      return callback()
    }
  }

  static validateArrayStringExpression (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    // console.log('-- validate array string min max', {
    //   value
    // })
    let attrName = rule.attrName
    let attrExpression = rule.attrExpression
    if (value && value.length > 0) {
      for (let v in value) {
        let val = value[v]
        let params = _.assign({}, val)
        if (rule.hasOwnProperty('attrName')) {
          val = val[attrName]
          if (params.hasOwnProperty(attrName)) delete params[attrName]
        }
        if (val == null) val = ''
        val = `${val}`
        params.value = val
        let result = Request.parseExpression(params, attrExpression, false)
        if (result === false) {
          return callback(new Error(rule.message || `Invalid format`))
        }
      }
      return callback()
    } else {
      return callback()
    }
  }

  // // array object -- not required, use basic structure instead
  //
  // static validateArrayObjectNumeric (rule, value, callback) {
  //   if (value && value.length > 0) {
  //     for (let v in value) {
  //       let val = value[v]
  //       if (typeof val !== 'object') {
  //         return callback(new Error('Invalid object'))
  //       }
  //       if (rule.hasOwnProperty('key')) {
  //         return callback(new Error('Invalid key'))
  //       }
  //       let key = rule.key
  //       let item = val[key]
  //       let type = 'float'
  //       if (rule.hasOwnProperty('type')) {
  //         type = rule.type
  //       }
  //       if (type === 'two-decimal') {
  //         // two decimal
  //         if (isNaN(parseFloat(item))) {
  //           return callback(new Error('Invalid format'))
  //         }
  //         if (!/^[+-]?\d*(\.\d)?\d{0,1}$/.test(item)) {
  //           return callback(new Error('Invalid format (two decimal place)'))
  //         }
  //       } else if (type === 'float') {
  //         if (isNaN(parseFloat(item))) {
  //           return callback(new Error('Invalid format'))
  //         }
  //         if (!/^[+-]?\d*(\.\d)?\d*$/.test(item)) {
  //           return callback(new Error('Invalid format (float)'))
  //         }
  //       } else {
  //         if (isNaN(parseFloat(item))) {
  //           return callback(new Error('Invalid format'))
  //         }
  //         if (!/^[+-]?\d*$/.test(item)) {
  //           return callback(new Error('Invalid format (int)'))
  //         }
  //       }
  //     }
  //     return callback()
  //   } else {
  //     return callback()
  //   }
  // }

  static validateUsername (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    let reg
    if (Constants.BrowserInfo && Constants.BrowserInfo.isSafari) {
      reg = /^(?=[a-zA-Z0-9._]{8,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/
    } else {
      // fix safari compile error
      // reg = /^(?=.{3,20}$)(?![-_.])(?!.*[-_.]{2})[a-zA-Z0-9.-_]+(?<![-_.])$/
      reg = new RegExp('^(?=.{3,20}$)(?![-_.])(?!.*[-_.]{2})[a-zA-Z0-9.-_]+(?<![-_.])$')
    }
    if (!reg.test(value)) {
      return callback(new Error('Invalid username format, allowed characters are a-z, A-Z, 0-9, .(dot), -(dash) and _(underscore)'))
    } else {
      return callback()
    }
  }

  // // phone
  //
  // static validatePhone (rule, value, callback) { // use validatorRegex
  //   let required
  //   if (rule && rule.hasOwnProperty('required')) {
  //     required = rule.required
  //   }
  //   if (required === false) {
  //     // ignore
  //     return callback()
  //   }
  //   let reg = new RegExp(`^(\\([0-9]{3}\\)|[0-9]{3}-)[0-9]{3}-[0-9]{4}$`)
  //   if (!reg.test(value)) {
  //     return callback(new Error('Invalid username format, allowed characters are a-z, A-Z, 0-9, .(dot), -(dash) and _(underscore)'))
  //   } else {
  //     return callback()
  //   }
  // }

  // email

  static REGEX_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  static validateEmail (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    const reg = Validators.REGEX_EMAIL
    if (!reg.test(value)) {
      return callback(new Error('Please enter the valid email address'))
    } else {
      return callback()
    }
  }

  // password, repassword

  static validatePassword (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    let form
    if (rule && rule.hasOwnProperty('form')) {
      form = rule.form
    }
    let compare
    if (rule && rule.hasOwnProperty('compare')) {
      compare = rule.compare
    }
    if (value.length < 6) {
      callback(new Error('The password can not be less than 6 characters'))
    } else {
      callback()
    }
    // cross validate
    if (this && this.$refs && this.$refs[form] && form && compare) {
      this.$refs[form].validateField(compare)
    }
  }

  static validateRePassword (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    let form
    if (rule && rule.hasOwnProperty('form')) {
      form = rule.form
    }
    let compare
    if (rule && rule.hasOwnProperty('compare')) {
      compare = rule.compare
    }
    if (value.length < 6) {
      return callback(new Error('The password can not be less than 6 characters'))
    } else if (!form || !compare) {
      return callback(new Error('Internal error with key form or compare'))
    } else if (this[form] && this[form][compare] !== value) {
      return callback(new Error('The password not match'))
    } else {
      return callback()
    }
  }

  // basics

  static validateCheckboxRequired (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }
    if (required === false) {
      // ignore
      return callback()
    }

    // value
    if (value === true) {
      return callback()
    } else {
      return callback(new Error('Required'))
    }
  }

  // validator - only digits

  static regexDigitsOnly () {
    return /^\d+$/
  }

  static validatorDigitsOnly (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }

    // value
    if (!required && !value) {
      return callback()
    }
    if (!required && typeof value === 'string' && value.length <= 0) {
      return callback()
    }
    if (!Validators.regexDigitsOnly().test(value)) {
      return callback(new Error('Invalid format, only 0-9 is allowed.'))
    }
    return callback()
  }

  // validator - float two decimal

  static regexFloatTwoDecimal () {
    return /^[+-]?\d*(\.\d)?\d{0,1}$/
  }

  static validateFloatTwoDecimal (value, required = true) {
    if (value === undefined || value === null) {
      return !required
    }
    value = (typeof value === 'number' ? `${value}` : value)
    if (value.length <= 0) {
      return !required
    }
    if (isNaN(parseFloat(value))) {
      return false
    }
    if (!Validators.regexFloatTwoDecimal().test(value)) {
      return false
    }
    return true
  }

  static validatorFloatTwoDecimal (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }

    // value
    if (!required && !value) {
      return callback()
    }
    if (!required && typeof value === 'string' && value.length <= 0) {
      return callback()
    }
    if (isNaN(parseFloat(value))) {
      return callback(new Error('Invalid format'))
    }
    if (!Validators.regexFloatTwoDecimal().test(value)) {
      return callback(new Error('Invalid format'))
    }
    return callback()
  }

  // validator - float

  static regexFloat () {
    return /^[+-]?\d*(\.\d)?\d*$/
  }

  static validateFloat (value, required = true) {
    if (value === undefined || value === null) {
      return !required
    }
    value = (typeof value === 'number' ? `${value}` : value)
    if (value.length <= 0) {
      return !required
    }
    if (isNaN(parseFloat(value))) {
      return false
    }
    if (!Validators.regexFloat().test(value)) {
      return false
    }
    return true
  }

  static validatorFloat (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }

    // value
    if (!required && !value) {
      return callback()
    }
    if (!required && typeof value === 'string' && value.length <= 0) {
      return callback()
    }
    if (isNaN(parseFloat(value))) {
      return callback(new Error('Invalid format'))
    }
    if (!Validators.regexFloat().test(value)) {
      return callback(new Error('Invalid format'))
    }
    return callback()
  }

  // validator - integer

  static regexInteger () {
    return /^[+-]?\d*$/
  }

  static validateInteger (value, required = true) {
    if (value === undefined || value === null) {
      return !required
    }
    value = (typeof value === 'number' ? `${value}` : value)
    if (value.length <= 0) {
      return !required
    }
    if (isNaN(parseInt(value, 10))) {
      return false
    }
    if (!Validators.regexInteger().test(value)) {
      return false
    }
    return true
  }

  static validatorInteger (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }

    // value
    if (!required && !value) {
      return callback()
    }
    if (!required && typeof value === 'string' && value.length <= 0) {
      return callback()
    }
    if (isNaN(parseFloat(value))) {
      return callback(new Error('Invalid format'))
    }
    if (!Validators.regexInteger().test(value)) {
      return callback(new Error('Invalid format'))
    }
    return callback()
  }

  // validator validator

  static validatorRegex (rule, value, callback) {
    // required
    let required
    if (rule && rule.hasOwnProperty('required')) {
      required = rule.required
    }

    // value
    if (required && StringHelper.isBlank(value)) {
      return callback(new Error('Required'))
    }
    if (!required && StringHelper.isBlank(value)) {
      return callback()
    }
    if (rule && !rule.hasOwnProperty('regex')) {
      console.error('invalid regex for validation')
      return callback()
    }
    let regex = rule.regex
    if (!regex.test(value)) {
      return callback(new Error((rule && rule.message) || 'Invalid regex format'))
    }
    return callback()
  }

  // validator server

  static validatorIsValid (rule, value, callback) {
    // required
    // let required
    // if (rule && rule.hasOwnProperty('required')) {
    //   required = rule.required
    // }
    if (!rule.hasOwnProperty('isValid')) {
      // ignore
      return callback()
    }
    // if (required === false) {
    //   // ignore
    //   return callback()
    // }

    // value
    if (!value) {
      return callback()
    }
    if (!rule.isValid) {
      return callback(new Error(rule.message || 'Invalid'))
    }
    return callback()
  }

  // check isValid if value is YES
  static validatorOptionsYesNoIsYes (rule, value, callback) {
    if (!rule.hasOwnProperty('isValid')) {
      // ignore
      return callback()
    }

    // value
    if (!value) {
      return callback()
    }
    if (!rule.isValid && value !== Constants.OptionsYesNo.NO) {
      return callback(new Error(rule.message || 'Invalid'))
    }
    return callback()
  }

  static generateFormErrors (form = {}, keyinfos = [], rules = {}) {
    let errors = []
    let isBlank = (value) => (value == null || `${value}`.length <= 0)
    for (let k in keyinfos) {
      let keyinfo = keyinfos[k]
      let key = keyinfo.key
      let vtype = keyinfo.type
      let rulelist = (rules.hasOwnProperty(key) && rules[key]) || []
      if (keyinfo.hasOwnProperty('isValidate') &&
        keyinfo.isValidate) {
        continue
      }
      let value = form[key]
      let isRequired = (_.find(rulelist, (rule) => rule.required) != null)
      let isEmail = keyinfo.isEmail
      switch (vtype) {
        case 'file':
          if (isRequired && (value == null || !Array.isArray(value))) {
            errors.push(`${key} internal error`)
          }
          if (value.length <= 0) {
            errors.push(`${key} is required`)
          }
          break
        case 'boolean':
          if (isRequired && value == null) {
            errors.push(`${key} is required`)
          }
          break
        case 'string':
          if (isRequired && isBlank(value)) {
            errors.push(`${key} is required`)
          }
          if (!isBlank(value) && isEmail && !Validators.REGEX_EMAIL.test(value)) {
            errors.push(`${key} invalid email format`)
          }
          break
        case 'int':
          if (isRequired && isBlank(value)) {
            errors.push(`${key} is required`)
          }
          break
        default:
          if (isRequired && isBlank(value)) {
            errors.push(`${key} is required`)
          }
          break
      }
    }
    return errors
  }
}

export default Validators
